<template>
  <div class="addRegister">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('financeAccount.collapseTitle.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <BasicInfo ref="basicInfo" :canEdit="canEdit" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050815422281692']"
        v-if="this.$route.name.indexOf('Detail') != -1"
        @click="canEdit = !canEdit"
        >{{ $t('functionBtn.editToggle') }}
      </el-button>
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050815423298013']"
        :disabled="!canEdit"
        @click="save()"
        >{{ $t('functionBtn.save') }}
      </el-button>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/account';
  import BasicInfo from './components/basicInfo';
  export default {
    name: 'baseEdit',
    components: {
      BasicInfo,
    },
    data() {
      return {
        activeNames: ['1'],
        canEdit: true,
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      if (this.$route.query.id) {
        // 修改、详情
        this.getDetail();
      }
      if (this.$route.name.indexOf('Detail') != -1) this.canEdit = false; // 详情
    },
    methods: {
      async getDetail() {
        // 请求详情
        this.loading.startLoading();
        let res = await this.$axios.post(API.GET_ACCOUNTDETAIL_BY_ID, { id: this.$route.query.id });
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            let allDetail = res.data.data;
            let basicInfo = this.$refs.basicInfo.baseData;
            Object.keys(basicInfo).map((item) => {
              return (basicInfo[item] = allDetail[item]);
            });
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      async save() {
        let basicInfo = this.$refs.basicInfo.exportChildData();
        if (basicInfo) {
          this.loading.startLoading();
          let params = this.$baseRequest.assignObj(basicInfo);
          let res = await this.$axios.post(API.SAVE_ACCOUNTDETAIL, params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              this.returnPath();
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          }
        }
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: { keepAlive: true },
          },
          toPath: {
            path: '/masterData/financeAccount',
            name: 'financeAccount',
            meta: { keepAlive: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
